// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AddressSharedStyles from "@ces/App/SharedStyles/LocationPage/LocationAddressStyles";
import { constants } from "@ces/XDL/constants";
import { xScreen } from "@ces/XDL/Utilities";
import { pickUpLocationInfoDisplayStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PickUpLocation";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

pickUpLocationInfoDisplayStyles.billingAddress = {
    address: AddressSharedStyles.address,
    editLink: {
        css: css`
            display: none;
        `,
    },
    heading: {
        variant: "h6",
        as: "p",
    } as TypographyProps,
    headingGridItem: {
        css: css`
            &&& {
                margin-bottom: 12px;
            }
        `,
    },
};

pickUpLocationInfoDisplayStyles.container = {
    gap: 0,
    offsetCss: css`
        flex-direction: row-reverse;
        justify-content: space-between;
        gap: 24px 0;
        ${xScreen("lte", constants.checkoutReview.tablet)} {
            &&& {
                flex-wrap: wrap-reverse;
                justify-content: flex-end;
            }
        }
    `,
};

pickUpLocationInfoDisplayStyles.billingAddressGridItem = pickUpLocationInfoDisplayStyles.locationAddressGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        &&& {
            max-width: 430px;
            ${xScreen("lt", "md")} {
                max-width: 100%;
            }
        }
    `,
};
